import { Typography, Paper } from "@mui/material"

const TooSmallInfo = () => {
  return (
    <Paper sx={{ m: 4, mt: 10, p: 2, bgcolor: "#eee" }}>
      <Typography>
        Die Bücherliste kann auf diesem Gerät nicht bearbeitet werden.
        <br />
        Bitte öffnen Sie die Seite auf einem Desktop-Gerät.
      </Typography>
    </Paper>
  )
}

export default TooSmallInfo
